export default __webpack_public_path__ + "static/media/2476.704dec46.png";